import request from '../../request'

export function fetchList(data) {
    return request({
        url: '/common-service/quality/notice/list',
        data,
        method: "post",
    })
}

export function add(data) {
    return request({
        url: '/common-service/quality/notice/add',
        data,
        method: "post",
    })
}

export function update(data) {
    return request({
        url: '/common-service/quality/notice/update',
        data,
        method: "post",
    })
}

export function fetchDetail(params) {
    return request({
        url: '/common-service/quality/notice/query/' + params.id,
    })
}

export function remove(data) {
    return request({
        url: '/common-service/quality/notice/del',
        data,
        method: "post",
    })
}